import { HttpStatusCode } from 'axios';
import { setActiveBudget } from '../../../services/budgetService.js';

const BudgetManager = () => {

  const updateBudgetBE = async (budgetObj) => {
    await setActiveBudget({
      name: budgetObj.name,
      year: budgetObj.year.toString(),
    });
  };

  const updateBudgetFE = (budgetObj, user, setUser) => {
    updateUserActiveBudget(budgetObj, user, setUser);
    return budgetObj;
  };

  const changeBudget = (budgetObj, user, setUser) => {
    updateBudgetBE(budgetObj);
    return updateBudgetFE(budgetObj, user, setUser);
  };

  const updateUserActiveBudget = (budgetObj, user, setUser) => {
    // if (!user) return;
    setUser({...user, activeBudget: budgetObj});
  };

  return {
    updateBudgetBE,
    updateBudgetFE,
    changeBudget,
  };
};

export default BudgetManager;

export const changeBudget = (budgetObj, user, setUser, onSuccess, onError, onBeforeStart, onFinish) => {
  onBeforeStart && onBeforeStart();
  setActiveBudget({
    name: budgetObj.name,
    year: budgetObj.year.toString(),
  }).then((res) => {
    if (res.status === HttpStatusCode.Ok) {
      setUser({...user, activeBudget: budgetObj});
      onSuccess && onSuccess();
    } else {
      onError && onError();
    }
  }).catch(() => {
    onError && onError();
  }).finally(() => onFinish && onFinish());
};
